export const COUNTRY_CENTROIDS = {
  "AS": {
    "x": -170.7007,
    "y": -14.3057,
    "name": "American Samoa"
  },
  "UM": {
    "x": 166.638,
    "y": 19.302,
    "name": "United States Minor Outlying Islands"
  },
  "CK": {
    "x": -159.7877,
    "y": -21.2226,
    "name": "Cook Islands"
  },
  "PF": {
    "x": -149.4004,
    "y": -17.6747,
    "name": "French Polynesia"
  },
  "NU": {
    "x": -169.8688,
    "y": -19.0523,
    "name": "Niue"
  },
  "PN": {
    "x": -128.315,
    "y": -24.3661,
    "name": "Pitcairn"
  },
  "WS": {
    "x": -172.4411,
    "y": -13.6343,
    "name": "Samoa"
  },
  "TK": {
    "x": -171.8527,
    "y": -9.1952,
    "name": "Tokelau"
  },
  "TO": {
    "x": -175.2042,
    "y": -21.1593,
    "name": "Tonga"
  },
  "WF": {
    "x": -178.1274,
    "y": -14.2834,
    "name": "Wallis and Futuna"
  },
  "SV": {
    "x": -88.8591,
    "y": 13.758,
    "name": "El Salvador"
  },
  "GT": {
    "x": -90.3122,
    "y": 15.8209,
    "name": "Guatemala"
  },
  "MX": {
    "x": -101.554,
    "y": 23.8744,
    "name": "Mexico"
  },
  "CA": {
    "x": -98.4168,
    "y": 57.5505,
    "name": "Canada"
  },
  "AR": {
    "x": -64.5324,
    "y": -35.6973,
    "name": "Argentina"
  },
  "FK": {
    "x": -58.7466,
    "y": -51.759,
    "name": "Falkland Islands"
  },
  "CL": {
    "x": -70.7686,
    "y": -37.8294,
    "name": "Chile"
  },
  "EC": {
    "x": -78.463,
    "y": -1.5643,
    "name": "Ecuador"
  },
  "PE": {
    "x": -74.1142,
    "y": -8.5227,
    "name": "Peru"
  },
  "BO": {
    "x": -64.4521,
    "y": -16.7312,
    "name": "Bolivia"
  },
  "BR": {
    "x": -54.3552,
    "y": -11.5246,
    "name": "Brazil"
  },
  "PY": {
    "x": -58.3891,
    "y": -23.4219,
    "name": "Paraguay"
  },
  "UY": {
    "x": -56.0192,
    "y": -32.782,
    "name": "Uruguay"
  },
  "GS": {
    "x": -36.7751,
    "y": -54.3767,
    "name": "South Georgia and South Sandwich Islands"
  },
  "AQ": {
    "x": -177.5645,
    "y": -77.1699,
    "name": "Antarctica"
  },
  "FJ": {
    "x": 177.9814,
    "y": -17.8225,
    "name": "Fiji"
  },
  "SH": {
    "x": -5.7174,
    "y": -15.963,
    "name": "Saint Helena"
  },
  "AI": {
    "x": -63.0601,
    "y": 18.2229,
    "name": "Anguilla"
  },
  "AG": {
    "x": -61.7853,
    "y": 17.0715,
    "name": "Antigua and Barbuda"
  },
  "AW": {
    "x": -69.9756,
    "y": 12.5156,
    "name": "Aruba"
  },
  "BS": {
    "x": -78.0728,
    "y": 24.7216,
    "name": "Bahamas"
  },
  "BB": {
    "x": -59.5574,
    "y": 13.1832,
    "name": "Barbados"
  },
  "BZ": {
    "x": -88.6827,
    "y": 17.2425,
    "name": "Belize"
  },
  "BM": {
    "x": -64.7459,
    "y": 32.3151,
    "name": "Bermuda"
  },
  "BQ": {
    "x": -62.9782,
    "y": 17.4919,
    "name": "Saint Eustatius"
  },
  "VG": {
    "x": -64.6241,
    "y": 18.422,
    "name": "British Virgin Islands"
  },
  "KY": {
    "x": -81.252,
    "y": 19.3112,
    "name": "Cayman Islands"
  },
  "CO": {
    "x": -72.6445,
    "y": 4.1878,
    "name": "Colombia"
  },
  "CR": {
    "x": -84.1467,
    "y": 9.8635,
    "name": "Costa Rica"
  },
  "CU": {
    "x": -79.6982,
    "y": 21.4762,
    "name": "Cuba"
  },
  "CW": {
    "x": -68.9694,
    "y": 12.2,
    "name": "Curacao"
  },
  "DM": {
    "x": -61.3605,
    "y": 15.4293,
    "name": "Dominica"
  },
  "DO": {
    "x": -70.435,
    "y": 18.7795,
    "name": "Dominican Republic"
  },
  "GF": {
    "x": -53.3223,
    "y": 3.8574,
    "name": "French Guiana"
  },
  "GD": {
    "x": -61.6794,
    "y": 12.1129,
    "name": "Grenada"
  },
  "GP": {
    "x": -61.5438,
    "y": 16.2442,
    "name": "Guadeloupe"
  },
  "GY": {
    "x": -58.9135,
    "y": 4.6821,
    "name": "Guyana"
  },
  "HT": {
    "x": -72.8929,
    "y": 18.8835,
    "name": "Haiti"
  },
  "HN": {
    "x": -86.4925,
    "y": 14.7404,
    "name": "Honduras"
  },
  "JM": {
    "x": -77.3036,
    "y": 18.1221,
    "name": "Jamaica"
  },
  "MQ": {
    "x": -61.0143,
    "y": 14.6427,
    "name": "Martinique"
  },
  "MS": {
    "x": -62.1869,
    "y": 16.7354,
    "name": "Montserrat"
  },
  "NI": {
    "x": -85.0161,
    "y": 12.8936,
    "name": "Nicaragua"
  },
  "PA": {
    "x": -80.1443,
    "y": 8.4395,
    "name": "Panama"
  },
  "PR": {
    "x": -66.4943,
    "y": 18.2162,
    "name": "Puerto Rico"
  },
  "BL": {
    "x": -62.8305,
    "y": 17.9056,
    "name": "Saint Barthelemy"
  },
  "KN": {
    "x": -62.7456,
    "y": 17.3147,
    "name": "Saint Kitts and Nevis"
  },
  "LC": {
    "x": -60.969,
    "y": 13.8957,
    "name": "Saint Lucia"
  },
  "MF": {
    "x": -63.0668,
    "y": 18.078,
    "name": "Saint Martin"
  },
  "PM": {
    "x": -56.3247,
    "y": 46.9515,
    "name": "Saint Pierre and Miquelon"
  },
  "VC": {
    "x": -61.1938,
    "y": 13.2548,
    "name": "Saint Vincent and the Grenadines"
  },
  "SX": {
    "x": -63.0688,
    "y": 18.0394,
    "name": "Sint Maarten"
  },
  "SR": {
    "x": -55.8555,
    "y": 4.0987,
    "name": "Suriname"
  },
  "TT": {
    "x": -61.3724,
    "y": 10.4155,
    "name": "Trinidad and Tobago"
  },
  "TC": {
    "x": -71.7406,
    "y": 21.7999,
    "name": "Turks and Caicos Islands"
  },
  "VI": {
    "x": -64.7616,
    "y": 17.738,
    "name": "US Virgin Islands"
  },
  "VE": {
    "x": -66.3649,
    "y": 7.1483,
    "name": "Venezuela"
  },
  "BF": {
    "x": -1.6933,
    "y": 12.1087,
    "name": "Burkina Faso"
  },
  "CV": {
    "x": -23.634,
    "y": 15.0764,
    "name": "Cabo Verde"
  },
  "CI": {
    "x": -5.5717,
    "y": 7.5368,
    "name": "Côte d'Ivoire"
  },
  "GM": {
    "x": -15.3834,
    "y": 13.4286,
    "name": "Gambia"
  },
  "GH": {
    "x": -1.2192,
    "y": 7.9453,
    "name": "Ghana"
  },
  "GI": {
    "x": -5.3455,
    "y": 36.1402,
    "name": "Gibraltar"
  },
  "GN": {
    "x": -10.9869,
    "y": 10.256,
    "name": "Guinea"
  },
  "GW": {
    "x": -14.9802,
    "y": 11.9801,
    "name": "Guinea-Bissau"
  },
  "LR": {
    "x": -9.259,
    "y": 6.5201,
    "name": "Liberia"
  },
  "ML": {
    "x": -4.3464,
    "y": 17.1681,
    "name": "Mali"
  },
  "MR": {
    "x": -10.4951,
    "y": 20.4667,
    "name": "Mauritania"
  },
  "MA": {
    "x": -8.8172,
    "y": 28.6876,
    "name": "Morocco"
  },
  "PT": {
    "x": -7.9337,
    "y": 39.6753,
    "name": "Portugal"
  },
  "SN": {
    "x": -14.6109,
    "y": 14.2289,
    "name": "Senegal"
  },
  "SL": {
    "x": -11.7866,
    "y": 8.5613,
    "name": "Sierra Leone"
  },
  "GL": {
    "x": -42.0757,
    "y": 74.1685,
    "name": "Greenland"
  },
  "GG": {
    "x": -2.5764,
    "y": 49.4587,
    "name": "Guernsey"
  },
  "IE": {
    "x": -8.2411,
    "y": 53.3049,
    "name": "Ireland"
  },
  "IM": {
    "x": -4.533,
    "y": 54.2286,
    "name": "Isle of Man"
  },
  "JE": {
    "x": -2.1292,
    "y": 49.2154,
    "name": "Jersey"
  },
  "GB": {
    "x": -2.8529,
    "y": 53.9784,
    "name": "United Kingdom"
  },
  "IS": {
    "x": -19.0568,
    "y": 65.1236,
    "name": "Iceland"
  },
  "FO": {
    "x": -6.9811,
    "y": 62.1309,
    "name": "Faroe Islands"
  },
  "SJ": {
    "x": 16.0364,
    "y": 78.5732,
    "name": "Svalbard"
  },
  "BV": {
    "x": 3.412,
    "y": -54.4232,
    "name": "Bouvet Island"
  },
  "NZ": {
    "x": 170.6904,
    "y": -43.8277,
    "name": "New Zealand"
  },
  "AO": {
    "x": 17.6518,
    "y": -12.1674,
    "name": "Angola"
  },
  "BW": {
    "x": 23.8578,
    "y": -22.2366,
    "name": "Botswana"
  },
  "BI": {
    "x": 29.8852,
    "y": -3.2613,
    "name": "Burundi"
  },
  "KM": {
    "x": 43.3483,
    "y": -11.6589,
    "name": "Comoros"
  },
  "CG": {
    "x": 14.8797,
    "y": -0.7294,
    "name": "Congo"
  },
  "CD": {
    "x": 23.4198,
    "y": -3.3386,
    "name": "Congo DRC"
  },
  "GA": {
    "x": 11.8394,
    "y": -0.6284,
    "name": "Gabon"
  },
  "KE": {
    "x": 37.9531,
    "y": 0.6899,
    "name": "Kenya"
  },
  "LS": {
    "x": 28.2448,
    "y": -29.6017,
    "name": "Lesotho"
  },
  "MW": {
    "x": 34.2344,
    "y": -13.129,
    "name": "Malawi"
  },
  "TF": {
    "x": 47.2909,
    "y": -11.5662,
    "name": "Glorioso Islands"
  },
  "MZ": {
    "x": 35.2086,
    "y": -17.5252,
    "name": "Mozambique"
  },
  "NA": {
    "x": 18.1645,
    "y": -21.9086,
    "name": "Namibia"
  },
  "RW": {
    "x": 29.9194,
    "y": -2.0147,
    "name": "Rwanda"
  },
  "ST": {
    "x": 6.6062,
    "y": 0.2274,
    "name": "Sao Tome and Principe"
  },
  "ZA": {
    "x": 24.7525,
    "y": -28.5536,
    "name": "South Africa"
  },
  "SZ": {
    "x": 31.5107,
    "y": -26.5625,
    "name": "Eswatini"
  },
  "TZ": {
    "x": 34.8183,
    "y": -6.3558,
    "name": "Tanzania"
  },
  "ZM": {
    "x": 27.7552,
    "y": -13.1628,
    "name": "Zambia"
  },
  "ZW": {
    "x": 29.7178,
    "y": -18.927,
    "name": "Zimbabwe"
  },
  "IO": {
    "x": 72.435,
    "y": -7.3235,
    "name": "British Indian Ocean Territory"
  },
  "HM": {
    "x": 73.493,
    "y": -53.0842,
    "name": "Heard Island and McDonald Islands"
  },
  "MG": {
    "x": 46.6849,
    "y": -19.0416,
    "name": "Madagascar"
  },
  "MU": {
    "x": 57.5642,
    "y": -20.2814,
    "name": "Mauritius"
  },
  "YT": {
    "x": 45.1281,
    "y": -12.8245,
    "name": "Mayotte"
  },
  "RE": {
    "x": 55.5439,
    "y": -21.1198,
    "name": "Réunion"
  },
  "SC": {
    "x": 55.4725,
    "y": -4.66,
    "name": "Seychelles"
  },
  "DZ": {
    "x": 2.6558,
    "y": 28.351,
    "name": "Algeria"
  },
  "BJ": {
    "x": 2.3057,
    "y": 9.503,
    "name": "Benin"
  },
  "CM": {
    "x": 12.9485,
    "y": 6.2942,
    "name": "Cameroon"
  },
  "CF": {
    "x": 20.5207,
    "y": 6.3314,
    "name": "Central African Republic"
  },
  "TD": {
    "x": 18.4271,
    "y": 15.2835,
    "name": "Chad"
  },
  "GQ": {
    "x": 10.4255,
    "y": 1.5955,
    "name": "Equatorial Guinea"
  },
  "KI": {
    "x": -157.3902,
    "y": 1.8677,
    "name": "Kiribati"
  },
  "LY": {
    "x": 17.9113,
    "y": 27.2029,
    "name": "Libya"
  },
  "MT": {
    "x": 14.4419,
    "y": 35.8905,
    "name": "Malta"
  },
  "NE": {
    "x": 8.8686,
    "y": 17.0811,
    "name": "Niger"
  },
  "NG": {
    "x": 8.1477,
    "y": 9.6103,
    "name": "Nigeria"
  },
  "TG": {
    "x": 0.8991,
    "y": 8.6607,
    "name": "Togo"
  },
  "TN": {
    "x": 9.6559,
    "y": 34.0864,
    "name": "Tunisia"
  },
  "CY": {
    "x": 33.3753,
    "y": 35.117,
    "name": "Cyprus"
  },
  "DJ": {
    "x": 42.6135,
    "y": 11.7502,
    "name": "Djibouti"
  },
  "EG": {
    "x": 30.2401,
    "y": 26.6052,
    "name": "Egypt"
  },
  "ER": {
    "x": 39.2672,
    "y": 15.0055,
    "name": "Eritrea"
  },
  "ET": {
    "x": 39.9149,
    "y": 8.7294,
    "name": "Ethiopia"
  },
  "GR": {
    "x": 23.1104,
    "y": 39.4201,
    "name": "Greece"
  },
  "IQ": {
    "x": 43.8325,
    "y": 33.1051,
    "name": "Iraq"
  },
  "IL": {
    "x": 35.0279,
    "y": 31.5135,
    "name": "Israel"
  },
  "JO": {
    "x": 36.9573,
    "y": 31.3871,
    "name": "Jordan"
  },
  "LB": {
    "x": 35.8965,
    "y": 33.9116,
    "name": "Lebanon"
  },
  "PS": {
    "x": 35.2425,
    "y": 31.9308,
    "name": "Palestinian Territory"
  },
  "SS": {
    "x": 30.3852,
    "y": 7.6578,
    "name": "South Sudan"
  },
  "SD": {
    "x": 29.9515,
    "y": 15.6706,
    "name": "Sudan"
  },
  "SY": {
    "x": 38.5117,
    "y": 35.0975,
    "name": "Syria"
  },
  "TR": {
    "x": 35.5689,
    "y": 38.9321,
    "name": "Turkey"
  },
  "UG": {
    "x": 32.3437,
    "y": 1.2822,
    "name": "Uganda"
  },
  "AD": {
    "x": 1.5802,
    "y": 42.5486,
    "name": "Andorra"
  },
  "US": {
    "x": -96.3316,
    "y": 38.8208,
    "name": "United States"
  },
  "FR": {
    "x": 2.194,
    "y": 46.6424,
    "name": "France"
  },
  "LI": {
    "x": 9.5477,
    "y": 47.1463,
    "name": "Liechtenstein"
  },
  "MC": {
    "x": 7.4128,
    "y": 43.748,
    "name": "Monaco"
  },
  "CH": {
    "x": 8.2869,
    "y": 46.7368,
    "name": "Switzerland"
  },
  "BE": {
    "x": 4.675,
    "y": 50.6182,
    "name": "Belgium"
  },
  "DE": {
    "x": 10.4262,
    "y": 51.083,
    "name": "Germany"
  },
  "LU": {
    "x": 6.1032,
    "y": 49.7752,
    "name": "Luxembourg"
  },
  "NL": {
    "x": 5.5541,
    "y": 52.1341,
    "name": "Netherlands"
  },
  "AL": {
    "x": 20.0611,
    "y": 41.1417,
    "name": "Albania"
  },
  "AT": {
    "x": 13.7978,
    "y": 47.6319,
    "name": "Austria"
  },
  "BA": {
    "x": 17.8347,
    "y": 44.1442,
    "name": "Bosnia and Herzegovina"
  },
  "HR": {
    "x": 16.6258,
    "y": 44.9119,
    "name": "Croatia"
  },
  "CZ": {
    "x": 15.3833,
    "y": 49.7492,
    "name": "Czech Republic"
  },
  "DK": {
    "x": 9.3787,
    "y": 56.0012,
    "name": "Denmark"
  },
  "HU": {
    "x": 19.3962,
    "y": 47.2253,
    "name": "Hungary"
  },
  "IT": {
    "x": 12.7637,
    "y": 42.982,
    "name": "Italy"
  },
  "ME": {
    "x": 19.2951,
    "y": 42.7369,
    "name": "Montenegro"
  },
  "PL": {
    "x": 19.4357,
    "y": 52.0685,
    "name": "Poland"
  },
  "SM": {
    "x": 12.4613,
    "y": 43.9428,
    "name": "San Marino"
  },
  "RS": {
    "x": 20.8568,
    "y": 44.0268,
    "name": "Serbia"
  },
  "SK": {
    "x": 19.581,
    "y": 48.6981,
    "name": "Slovakia"
  },
  "SI": {
    "x": 14.8906,
    "y": 46.1376,
    "name": "Slovenia"
  },
  "MK": {
    "x": 21.71,
    "y": 41.594,
    "name": "North Macedonia"
  },
  "VA": {
    "x": 12.4513,
    "y": 41.904,
    "name": "Vatican City"
  },
  "NO": {
    "x": 16.6703,
    "y": 64.9778,
    "name": "Norway"
  },
  "SE": {
    "x": 17.0624,
    "y": 62.7342,
    "name": "Sweden"
  },
  "BY": {
    "x": 27.9643,
    "y": 53.4679,
    "name": "Belarus"
  },
  "BG": {
    "x": 25.2517,
    "y": 42.8204,
    "name": "Bulgaria"
  },
  "EE": {
    "x": 25.9169,
    "y": 58.6481,
    "name": "Estonia"
  },
  "FI": {
    "x": 25.6574,
    "y": 65.0158,
    "name": "Finland"
  },
  "GE": {
    "x": 43.3789,
    "y": 42.1799,
    "name": "Georgia"
  },
  "LV": {
    "x": 24.6937,
    "y": 56.8139,
    "name": "Latvia"
  },
  "LT": {
    "x": 23.946,
    "y": 55.2944,
    "name": "Lithuania"
  },
  "MD": {
    "x": 28.3911,
    "y": 47.0726,
    "name": "Moldova"
  },
  "RO": {
    "x": 25.0942,
    "y": 45.8245,
    "name": "Romania"
  },
  "UA": {
    "x": 31.2738,
    "y": 48.6575,
    "name": "Ukraine"
  },
  "AF": {
    "x": 66.5922,
    "y": 34.134,
    "name": "Afghanistan"
  },
  "BH": {
    "x": 50.5407,
    "y": 26.048,
    "name": "Bahrain"
  },
  "IN": {
    "x": 81.173,
    "y": 23.5863,
    "name": "India"
  },
  "IR": {
    "x": 54.2371,
    "y": 32.906,
    "name": "Iran"
  },
  "KW": {
    "x": 47.5631,
    "y": 29.2814,
    "name": "Kuwait"
  },
  "MV": {
    "x": 73.1008,
    "y": -0.6066,
    "name": "Maldives"
  },
  "NP": {
    "x": 84.1339,
    "y": 28.3009,
    "name": "Nepal"
  },
  "OM": {
    "x": 55.8411,
    "y": 20.7243,
    "name": "Oman"
  },
  "PK": {
    "x": 69.0884,
    "y": 30.1162,
    "name": "Pakistan"
  },
  "QA": {
    "x": 51.1979,
    "y": 25.3185,
    "name": "Qatar"
  },
  "SA": {
    "x": 44.601,
    "y": 24.136,
    "name": "Saudi Arabia"
  },
  "SO": {
    "x": 45.4004,
    "y": 6.5245,
    "name": "Somalia"
  },
  "LK": {
    "x": 80.6693,
    "y": 7.6966,
    "name": "Sri Lanka"
  },
  "TJ": {
    "x": 70.9422,
    "y": 38.5693,
    "name": "Tajikistan"
  },
  "TM": {
    "x": 58.4577,
    "y": 39.0607,
    "name": "Turkmenistan"
  },
  "AE": {
    "x": 54.2792,
    "y": 24.1825,
    "name": "United Arab Emirates"
  },
  "YE": {
    "x": 47.4682,
    "y": 16.0014,
    "name": "Yemen"
  },
  "AM": {
    "x": 45.0549,
    "y": 40.1784,
    "name": "Armenia"
  },
  "AZ": {
    "x": 48.6346,
    "y": 40.3921,
    "name": "Azerbaijan"
  },
  "KZ": {
    "x": 66.3759,
    "y": 47.6415,
    "name": "Kazakhstan"
  },
  "KG": {
    "x": 74.1753,
    "y": 41.357,
    "name": "Kyrgyzstan"
  },
  "UZ": {
    "x": 63.8548,
    "y": 41.4879,
    "name": "Uzbekistan"
  },
  "CX": {
    "x": 105.7021,
    "y": -10.4464,
    "name": "Christmas Island"
  },
  "CC": {
    "x": 96.8369,
    "y": -12.1712,
    "name": "Cocos Islands"
  },
  "ID": {
    "x": 113.9654,
    "y": 0.1559,
    "name": "Indonesia"
  },
  "TL": {
    "x": 125.9502,
    "y": -8.8099,
    "name": "Timor-Leste"
  },
  "AU": {
    "x": 134.0228,
    "y": -25.6973,
    "name": "Australia"
  },
  "NR": {
    "x": 166.9294,
    "y": -0.5221,
    "name": "Nauru"
  },
  "NC": {
    "x": 165.5077,
    "y": -21.33,
    "name": "New Caledonia"
  },
  "NF": {
    "x": 167.9526,
    "y": -29.0377,
    "name": "Norfolk Island"
  },
  "PG": {
    "x": 144.8349,
    "y": -7.1569,
    "name": "Papua New Guinea"
  },
  "SB": {
    "x": 160.1648,
    "y": -9.6131,
    "name": "Solomon Islands"
  },
  "TV": {
    "x": 179.2178,
    "y": -8.5147,
    "name": "Tuvalu"
  },
  "VU": {
    "x": 166.8491,
    "y": -15.1891,
    "name": "Vanuatu"
  },
  "KH": {
    "x": 105.0397,
    "y": 12.6992,
    "name": "Cambodia"
  },
  "LA": {
    "x": 103.7638,
    "y": 18.1173,
    "name": "Laos"
  },
  "MY": {
    "x": 114.6333,
    "y": 3.6717,
    "name": "Malaysia"
  },
  "MM": {
    "x": 97.0889,
    "y": 19.9012,
    "name": "Myanmar"
  },
  "SG": {
    "x": 103.8103,
    "y": 1.3528,
    "name": "Singapore"
  },
  "TH": {
    "x": 101.0868,
    "y": 13.6622,
    "name": "Thailand"
  },
  "VN": {
    "x": 105.9134,
    "y": 16.5173,
    "name": "Vietnam"
  },
  "BD": {
    "x": 90.4321,
    "y": 23.6737,
    "name": "Bangladesh"
  },
  "BT": {
    "x": 90.4672,
    "y": 27.4216,
    "name": "Bhutan"
  },
  "CN": {
    "x": 104.6911,
    "y": 38.0733,
    "name": "China"
  },
  "BN": {
    "x": 114.6431,
    "y": 4.5432,
    "name": "Brunei Darussalam"
  },
  "PH": {
    "x": 121.8221,
    "y": 15.5865,
    "name": "Philippines"
  },
  "KR": {
    "x": 127.7622,
    "y": 36.4024,
    "name": "South Korea"
  },
  "MN": {
    "x": 103.3987,
    "y": 47.0864,
    "name": "Mongolia"
  },
  "KP": {
    "x": 127.338,
    "y": 40.192,
    "name": "North Korea"
  },
  "GU": {
    "x": 144.7802,
    "y": 13.4454,
    "name": "Guam"
  },
  "JP": {
    "x": 137.4693,
    "y": 36.7674,
    "name": "Japan"
  },
  "MH": {
    "x": 168.7202,
    "y": 7.3079,
    "name": "Marshall Islands"
  },
  "FM": {
    "x": 158.2292,
    "y": 6.8789,
    "name": "Micronesia"
  },
  "MP": {
    "x": 145.7412,
    "y": 15.1781,
    "name": "Northern Mariana Islands"
  },
  "PW": {
    "x": 134.5797,
    "y": 7.5348,
    "name": "Palau"
  },
  "RU": {
    "x": 98.6705,
    "y": 59.0394,
    "name": "Russian Federation"
  },
  "ES": {
    "x": -16.538,
    "y": 28.2977,
    "name": "Canarias"
  }
} as const

export type CountryCentroidCode = keyof typeof COUNTRY_CENTROIDS
